import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import cn from "classnames";
import InfoPage from ".";

const ProfileSelector = () => {
  const navigate = useNavigate();
  const [hoveredLogin, setHoveredLogin] = useState(null); // Track which login button is hovered
  const [selectedProfiles, setSelectedProfiles] = useState([]);

  const toggleProfile = (profile) => {
    setSelectedProfiles((prev) => (
      prev.includes(profile) ? prev.filter(p => p !== profile) : [...prev, profile]
    ));
  };

  const below = (
    <>
      <style>{`
        @media only screen and (max-width: 767px) {
          .profile-selector-container {
            margin-top: 40px !important;
            min-height: 400px !important;
            padding: 0 16px !important;
          }
          .profile-selector-title {
            margin-bottom: 12px !important;
            font-size: clamp(20px, 6vw, 28px) !important;
          }
          .profile-selector-subtitle {
            margin-bottom: 32px !important;
            font-size: clamp(14px, 4vw, 16px) !important;
            padding: 0 8px;
          }
          .profile-selector-grid {
            grid-template-columns: 1fr !important;
            gap: 24px !important;
            padding: 0 0 !important;
            max-width: 100% !important;
          }
          .profile-selector-card {
            padding: 32px 24px !important;
          }
          .profile-selector-card-title {
            font-size: clamp(20px, 5vw, 24px) !important;
            margin-bottom: 12px !important;
          }
          .profile-selector-card-description {
            font-size: 14px !important;
            margin-bottom: 24px !important;
          }
          .profile-selector-card-buttons {
            gap: 12px !important;
          }
          .profile-selector-button {
            padding: 12px 20px !important;
            font-size: 14px !important;
          }
          .profile-selector-login-button {
            display: none !important;
          }
        }
        @media only screen and (max-width: 474px) {
          .profile-selector-container {
            margin-top: 32px !important;
            min-height: 350px !important;
          }
          .profile-selector-card {
            padding: 24px 20px !important;
          }
          .profile-selector-card-title {
            font-size: 18px !important;
          }
          .profile-selector-card-description {
            font-size: 13px !important;
          }
        }
      `}</style>
      <div className="profile-selector-container" style={{ 
        gridColumn: '1 / -1',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        minHeight: '500px',
        marginTop: '80px'
      }}>
        <h2 className="profile-selector-title" style={{ 
          margin: 0, 
          color: '#0f084b',
          fontSize: 'clamp(24px, 5vw, 32px)',
          fontWeight: 700,
          marginBottom: '16px'
        }}>
          Choose your profile type
        </h2>
        <div className="profile-selector-subtitle" style={{ 
          color: '#0f084b', 
          opacity: .85,
          fontSize: 'clamp(14px, 3vw, 16px)',
          marginBottom: '56px'
        }}>
          Select whether you're a Creator, Host, or Traveler
        </div>

        <div style={{ marginBottom: '32px', width: '100%', maxWidth: '720px', background: '#fff', border: '1px solid #e6e8ec', borderRadius: '16px', padding: '20px' }}>
          <h3 style={{ margin: '0 0 12px', color: '#0f084b' }}>Need more than one profile?</h3>
          <p style={{ margin: '0 0 16px', color: '#0f084b', opacity: 0.75 }}>
            Select every profile you need and create one All-Access login. Partner access still requires an application.
          </p>
          <div style={{ display: 'flex', gap: '16px', justifyContent: 'center', flexWrap: 'wrap', marginBottom: '16px' }}>
            {['creator', 'host', 'traveler'].map((profile) => (
              <label key={profile} style={{ display: 'flex', alignItems: 'center', gap: '8px', color: '#0f084b', textTransform: 'capitalize' }}>
                <input type="checkbox" checked={selectedProfiles.includes(profile)} onChange={() => toggleProfile(profile)} />
                {profile}
              </label>
            ))}
          </div>
          <div style={{ display: 'flex', gap: '12px', justifyContent: 'center', flexWrap: 'wrap' }}>
            <button
              className="button"
              type="button"
              disabled={!selectedProfiles.length}
              onClick={() => navigate(`/multi-signup?personas=${selectedProfiles.join(',')}`)}
            >
              Create All-Access Login
            </button>
            <button className="button-stroke" type="button" onClick={() => navigate('/partner-signup')}>
              Apply to be a Partner
            </button>
          </div>
        </div>
        
        <div className="profile-selector-grid" style={{ 
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))',
          gap: '32px',
          width: '100%',
          maxWidth: '1000px',
          padding: '0 20px'
        }}>
        {/* Creator Card */}
        <div className="profile-selector-card" style={{
          background: '#ffffff',
          border: '2px solid #e6e8ec',
          borderRadius: '16px',
          padding: '40px 32px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          transition: 'all 0.3s ease'
        }}>
          <h3 className="profile-selector-card-title" style={{
            margin: '0 0 16px 0',
            color: '#0f084b',
            fontSize: 'clamp(22px, 4vw, 28px)',
            fontWeight: 700
          }}>
            Creator
          </h3>
          <p className="profile-selector-card-description" style={{
            margin: '0 0 32px 0',
            color: '#0f084b',
            opacity: 0.7,
            fontSize: '15px',
            textAlign: 'center',
            lineHeight: '1.6'
          }}>
            Content creators and influencers looking to collaborate
          </p>
          <div className="profile-selector-card-buttons" style={{
            display: 'flex',
            gap: '16px',
            width: '100%',
            flexDirection: 'column'
          }}>
            <button 
              className={cn('button-stroke', 'profile-selector-button', 'profile-selector-login-button')} 
              onClick={() => navigate('/creator-login')}
              onMouseEnter={() => setHoveredLogin('creator')}
              onMouseLeave={() => setHoveredLogin(null)}
              style={{ 
                width: '100%',
                padding: '14px 24px',
                borderColor: '#0f084b',
                color: hoveredLogin === 'creator' ? '#ffffff' : '#0f084b',
                background: hoveredLogin === 'creator' ? '#0f084b' : 'transparent',
                transition: 'all 0.2s ease'
              }}
            >
              Login
            </button>
            <button 
              className={cn('button', 'profile-selector-button')} 
              onClick={() => navigate('/creator-signup')}
              style={{ 
                width: '100%',
                padding: '14px 24px',
                background: '#dc1d08'
              }}
            >
              Get Started
            </button>
          </div>
        </div>

        {/* Host Card */}
        <div className="profile-selector-card" style={{
          background: '#ffffff',
          border: '2px solid #e6e8ec',
          borderRadius: '16px',
          padding: '40px 32px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          transition: 'all 0.3s ease'
        }}>
          <h3 className="profile-selector-card-title" style={{
            margin: '0 0 16px 0',
            color: '#0f084b',
            fontSize: 'clamp(22px, 4vw, 28px)',
            fontWeight: 700
          }}>
            Host
          </h3>
          <p className="profile-selector-card-description" style={{
            margin: '0 0 32px 0',
            color: '#0f084b',
            opacity: 0.7,
            fontSize: '15px',
            textAlign: 'center',
            lineHeight: '1.6'
          }}>
            Property owners, hotels, and tourism boards
          </p>
          <div className="profile-selector-card-buttons" style={{
            display: 'flex',
            gap: '16px',
            width: '100%',
            flexDirection: 'column'
          }}>
            <button 
              className={cn('button-stroke', 'profile-selector-button', 'profile-selector-login-button')} 
              onClick={() => navigate('/host-login')}
              onMouseEnter={() => setHoveredLogin('host')}
              onMouseLeave={() => setHoveredLogin(null)}
              style={{ 
                width: '100%',
                padding: '14px 24px',
                borderColor: '#0f084b',
                color: hoveredLogin === 'host' ? '#ffffff' : '#0f084b',
                background: hoveredLogin === 'host' ? '#0f084b' : 'transparent',
                transition: 'all 0.2s ease'
              }}
            >
              Login
            </button>
            <button 
              className={cn('button', 'profile-selector-button')} 
              onClick={() => navigate('/host-select')}
              style={{ 
                width: '100%',
                padding: '14px 24px',
                background: '#dc1d08'
              }}
            >
              Get Started
            </button>
          </div>
        </div>

        {/* Traveler Card */}
        <div className="profile-selector-card" style={{
          background: '#ffffff',
          border: '2px solid #e6e8ec',
          borderRadius: '16px',
          padding: '40px 32px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          transition: 'all 0.3s ease'
        }}>
          <h3 className="profile-selector-card-title" style={{
            margin: '0 0 16px 0',
            color: '#0f084b',
            fontSize: 'clamp(22px, 4vw, 28px)',
            fontWeight: 700
          }}>
            Traveler
          </h3>
          <p className="profile-selector-card-description" style={{
            margin: '0 0 32px 0',
            color: '#0f084b',
            opacity: 0.7,
            fontSize: '15px',
            textAlign: 'center',
            lineHeight: '1.6'
          }}>
            Travelers looking for unique stays and experiences
          </p>
          <div className="profile-selector-card-buttons" style={{
            display: 'flex',
            gap: '16px',
            width: '100%',
            flexDirection: 'column'
          }}>
            <button 
              className={cn('button-stroke', 'profile-selector-button', 'profile-selector-login-button')} 
              onClick={() => navigate('/traveler-login')}
              onMouseEnter={() => setHoveredLogin('traveler')}
              onMouseLeave={() => setHoveredLogin(null)}
              style={{ 
                width: '100%',
                padding: '14px 24px',
                borderColor: '#0f084b',
                color: hoveredLogin === 'traveler' ? '#ffffff' : '#0f084b',
                background: hoveredLogin === 'traveler' ? '#0f084b' : 'transparent',
                transition: 'all 0.2s ease'
              }}
            >
              Login
            </button>
            <button 
              className={cn('button', 'profile-selector-button')} 
              onClick={() => navigate('/traveler-signup')}
              style={{ 
                width: '100%',
                padding: '14px 24px',
                background: '#dc1d08'
              }}
            >
              Get Started
            </button>
          </div>
        </div>
      </div>
    </div>
    </>
  );

  return (
    <InfoPage title="" below={below} tallOverride={false} customMinHeight={900} disableStamps />
  );
};

export default ProfileSelector;
